<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="openNewMeasurementWizard()"
>
  <div class="wrapper--spacing-all">
    <app-measurements-overview></app-measurements-overview>
  </div>
</agr-page-toolbar>
